import { Children, cloneElement, isValidElement } from "react";

export const extendClone = (props, children) => (children && props) ? Children.map(children, child => 
    isValidElement(child) ?
        cloneElement(child, props) :
        child
) : children;